export const tempUserCredentialsSchema = {
    $id: 'urn:wisepipe-common-auth:TempUserCredentials',
    type: 'object',
    properties: {
        idToken: { type: 'string', pattern: '[A-Za-z0-9-_=.]+' },
        refreshToken: { type: 'string', pattern: '[A-Za-z0-9-_=.]+' },
        accessToken: { type: 'string' }
    },
    required: ['idToken', 'refreshToken']
};
//# sourceMappingURL=tempUserCredentials.js.map